import { render, staticRenderFns } from "./TicketTable.vue?vue&type=template&id=63906093&scoped=true"
import script from "./TicketTable.vue?vue&type=script&lang=js"
export * from "./TicketTable.vue?vue&type=script&lang=js"
import style0 from "./TicketTable.vue?vue&type=style&index=0&id=63906093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63906093",
  null
  
)

export default component.exports